module.exports = __webpack_public_path__ + "static/img/logo.e6e5fb76.svg";